import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { getPolicyStatus, getStatusButtonClass } from 'src/utils/commonMethods'
import { Grid } from '@mui/material'

const MotorFullDetails = ({ activePolicy }) => {
  const classes = useStyles()

  return (
    <>
      <Grid container spacing={1} direction='column' className={classes.root}>
        <Grid item xs={12} sm={12} lg={12} flexGrow={1}>
          <img
            src={activePolicy?.productImage}
            className={classes.providerImage}
            alt='Product'
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.provider}
            alignItems={'center'}
          >
            {activePolicy?.productSubType ? activePolicy?.productSubType : '-'}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.title}
            alignItems={'center'}
          >
            {activePolicy?.otherInformation !== null && (
              <div>
                <p className={classes.activePolicyInfo}>
                  {activePolicy?.otherInformation?.vehicleMakeModel === ''
                    ? '---'
                    : activePolicy?.otherInformation?.vehicleMakeModel}
                </p>
              </div>
            )}
            {activePolicy?.otherInformation !== null && (
              <div>
                <p className={classes.itemHeading}>
                  {activePolicy?.otherInformation?.vehicleNumber === ''
                    ? '---'
                    : activePolicy?.otherInformation?.vehicleNumber}
                </p>
              </div>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.policyDetails}
            alignItems={'center'}
          >
            <span className={classes.sumInsuredTableText1}>Insured Name:</span>{' '}
            <span className={classes.sumInsuredTableText1Bold}>
              {activePolicy?.otherInformation !== null && (
                <span>
                  {activePolicy?.otherInformation?.insuredName === ''
                    ? '---'
                    : activePolicy?.otherInformation?.insuredName}
                </span>
              )}
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.policyDetails}
            alignItems={'center'}
          >
            <span className={classes.sumInsuredTableText1}>Policy No:</span>{' '}
            <span className={classes.sumInsuredTableText1Bold}>
              {activePolicy?.policyNumber !== null
                ? activePolicy?.policyNumber
                : '-'}
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.statusContainer}
            alignItems={'center'}
          >
            <Button
              className={getStatusButtonClass(activePolicy?.status)}
              disabled
            >
              {getPolicyStatus(activePolicy?.status)}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default MotorFullDetails

const useStyles = makeStyles({
  root: {
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    background: 'linear-gradient(45deg, #eeeeee 0%,#ffffff 100%)',
    justifyContent: 'space-around',
    padding: '10px',
  },
  icon: {
    padding: '0px 0px 0px 10px',
    flexShrink: 0,
    '& svg': {
      maxWidth: '100%',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
  activePolicyInfo: {
    margin: '0px',
  },
  icon1: {
    padding: '0px 10px 0px 0px',
    flexShrink: 0,
    '& svg': {
      maxWidth: '100%',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
  btn: {
    backgroundColor: COLORS.DARK_PINK,
    color: COLORS.WHITE,
    borderRadius: '60px',
    padding: '3px 16px',
    fontSize: '12px',
    width: 'max-content',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: COLORS.PINK_01,
    },
  },
  productSubtypeHeading: {
    margin: '0px 0px',
    color: COLORS.DARK_PINK,
    fontSize: '16px',
    fontWeight: 'bold',
  },
  divOtherInformation: {
    paddingBottom: '10px',
    color: COLORS.GREY,
    fontSize: '14px',
  },
  itemHeading: {
    margin: '0px 0px',
    fontWeight: 'bold',
  },

  policyDetails: {
    '@media (max-width:1200px)': {
      alignItems: 'center !important',
    },
  },
  sumInsuredTableText1: {
    fontWeight: '500',
    color: COLORS.GREY,
    fontSize: '12px',
    margin: '0px 0px',
    alignItems: 'center',
    '@media (min-width:1600px)': {
      fontSize: '16px',
    },
    '@media (max-width:1200px)': {
      fontSize: '11px',
      alignItems: 'center !important',
    },
  },
  sumInsuredTableText1Bold: {
    fontWeight: '800',
    color: COLORS.GREY,
    fontSize: '12px',
    margin: '0px 0px',
    '@media (min-width:1600px)': {
      fontSize: '16px',
    },
    '@media (max-width:1200px)': {
      fontSize: '11px',
      alignItems: 'center !important',
    },
  },
  title: {
    fontSize: '10px',
    fontWeight: 'bold',
    textAlign: 'center !important',
    color: COLORS.BLACK,
    '& button': {
      marginTop: '15px',
    },
    '@media (min-width:1600px)': {
      fontSize: '14px',
    },
    '@media (max-width:1200px)': {
      fontSize: '9px',
    },
  },
  provider: {
    fontSize: '15px',
    fontWeight: 'bold',
    textAlign: 'center !important',
    color: COLORS.DARK_PINK,
    '@media (min-width:1600px)': {
      fontSize: '18px',
    },
    '@media (max-width:1200px)': {
      fontSize: '11px',
      alignItems: 'center !important',
    },
    '& button': {
      marginTop: '15px',
    },
  },
  providerImage: {
    width: '35px',
    cursor: 'pointer',
  },
})
